import { PORTALS_ACTIONS, initialPortalsState } from './portals.types'

/**
 *
 * @param {import('./portals.types').PortalsSlice} state
 * @param {import('./portals.types'.PortalsAction)} action
 * @returns
 */
export function portalsReducer(state = initialPortalsState, { type, payload }) {
  switch (type) {
    case PORTALS_ACTIONS.SET_PORTALS_STATUS:
      return {
        ...state,
        status: payload
      }

    case PORTALS_ACTIONS.SET_PORTALS_ERRORS:
      return {
        ...state,
        errors: [payload, ...state.errors]
      }

    case PORTALS_ACTIONS.SET_PORTALS_TASK:
      return {
        ...state,
        task: payload
      }

    case PORTALS_ACTIONS.SET_PORTALS_DATA:
      return {
        ...state,
        data: Object.fromEntries(payload.map(portal => [portal.id, portal]))
      }

    case PORTALS_ACTIONS.SET_PORTAL_OPTIONS:
      return {
        ...state,
        options: payload
      }

    case PORTALS_ACTIONS.ADD_PORTAL:
      return {
        ...state,
        data: { ...state.data, [payload.id]: payload }
      }

    case PORTALS_ACTIONS.UPDATE_PORTAL:
      return {
        ...state,
        data: { ...state.data, [payload.id]: { ...state.data[payload.id], ...payload } }
      }

    case PORTALS_ACTIONS.DELETE_PORTAL:
      return {
        ...state,
        data: Object.fromEntries(Object.entries(state.data).filter(([id]) => id !== payload))
      }

    case PORTALS_ACTIONS.CLEAR_PORTALS_ERRORS:
      return {
        ...state,
        errors: []
      }

    case PORTALS_ACTIONS.CLEAR_PORTALS_TASK:
      return {
        ...state,
        task: null
      }

    default:
      return state
  }
}
